import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useAvailability = (date) => {
  return useQuery({
    queryKey: ["availability", date],
    queryFn: ({ signal }) => {
      return fetch({
        url: `${Angie.api_url}/users/unavailable-users${date ? `?date=${date}` : ""}`,
        signal,
      });
    },
  });
};
